export const OVERRIDEN_ERROR_MESSAGES = [
  "Absence already approved",
  "Absence already rejected",
  "Absence already cancelled",
  "Absence already accepted by client",
  "Absence already rejected by client",
  "Extra hour already approved",
  "Extra hour already rejected",
  "Extra hour already cancelled",
  "Extra hours already accepted by client",
  "Extra hours already rejected by client",
  "Extra hours already cancelled",
  "Extra hours already approved",
  "Extra hours already rejected",
  "Expense report already approved",
  "Expense report already rejected",
  "Expense report already rejected by client",
  "Expense report already cancelled",
  "Expense report already approved and marked as paid",
  "Expense report already accepted",
  "Expense report already accepted by client",
  "Sign-off request is already signed",
  "Absence cancellation  request already approved",
  "Absence cancellation  request already rejected",
  "This signed off has been canceled",
];
